import React from 'react';
import { Box, Typography, TextField, Paper } from '@mui/material';

function CustomScript({ formData, setFormData }) {
  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      customScript: {
        ...prev.customScript,
        [field]: e.target.value,
      },
    }));
  };

  return (
    <Paper
      elevation={2}
      sx={{
        p: 4,
        borderRadius: 3,
        backgroundColor: '#fafafa',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Script Settings
        </Typography>

        {/* Script Path + Timeout Box */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 2,
            flexWrap: { xs: 'wrap', md: 'nowrap' },
          }}
        >
          {/* Script Path */}
          <TextField
            label="Script File Path"
            variant="outlined"
            fullWidth
            placeholder="/usr/local/scripts/cleanse_email.py"
            value={formData.customScript?.filePath || ''}
            onChange={handleChange('filePath')}
            InputProps={{
              sx: { borderRadius: 2, backgroundColor: 'white' },
            }}
          />

          {/* Timeout & Retries */}
          <Paper
            elevation={0}
            sx={{
              p: 2,
              borderRadius: 2,
              backgroundColor: '#f9f9f9',
              border: '1px solid #e0e0e0',
              minWidth: 180,
            }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#444' }}>
              Timeout and Retries
            </Typography>
            <Typography variant="body2" sx={{ color: '#555' }}>
              Timeout: 5s <br />
              Retries: 1
            </Typography>
          </Paper>
        </Box>

        {/* Function Name */}
        <TextField
          label="Function Name"
          variant="outlined"
          fullWidth
          placeholder="cleanse_email"
          value={formData.customScript?.functionName || ''}
          onChange={handleChange('functionName')}
          InputProps={{
            sx: { borderRadius: 2, backgroundColor: 'white' },
          }}
        />

        {/* Parameters */}
        <TextField
          label="Input Parameters (JSON)"
          variant="outlined"
          fullWidth
          multiline
          rows={3}
          placeholder={`{ "email": "{{Customer.Email}}", "country": "{{Customer.Country}}" }`}
          value={formData.customScript?.parameters || ''}
          onChange={handleChange('parameters')}
          InputProps={{
            sx: { borderRadius: 2, backgroundColor: '#f9f9f9' },
          }}
        />

        {/* Output Mapping */}
        <TextField
          label="Output Variable"
          variant="outlined"
          fullWidth
          placeholder="cleanedEmail"
          value={formData.customScript?.outputVar || ''}
          onChange={handleChange('outputVar')}
          InputProps={{
            sx: { borderRadius: 2, backgroundColor: 'white' },
          }}
        />

        {/* Script Code Editor */}
        <TextField
          label="Script Code (Python / JavaScript)"
          variant="outlined"
          fullWidth
          multiline
          rows={6}
          placeholder={`def cleanse_email(email):\n    return email.strip().lower()`}
          value={formData.customScript?.scriptCode || ''}
          onChange={handleChange('scriptCode')}
          InputProps={{
            sx: { borderRadius: 2, backgroundColor: '#f9f9f9', fontFamily: 'monospace' },
          }}
        />
      </Box>
    </Paper>
  );
}

export default CustomScript;
